import React from "react";

const GameFrameBackground = () => <svg data-name="game-frame-background">
    <rect className="game-frame-background" x="0.12" y="0.12" width="1529" height="860"/>
</svg>;

export default GameFrameBackground;
